

// import React, { useEffect, useState } from "react";
// import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
// import "./idex.css"; // Custom CSS


// import axios from "axios";
// import Navbar from "../Home/Navbar";
// import Footer from "../Home/Footer";

// const PaymentStatus = () => {
//   const [loading, setLoading] = useState(true);
//   const [isSuccessful, setIsSuccessful] = useState(null);
//   const [statusMessage, setStatusMessage] = useState("");
//   const [transactionId, setTransactionId] = useState(null);

//   useEffect(() => {
//     const fetchPaymentStatus = async () => {
//       const urlSegments = window.location.pathname.split("/");
//       const orderId = urlSegments[urlSegments.length - 2]; // Adjust based on your URL structure
//       const clientId = urlSegments[urlSegments.length - 1];

//       setTransactionId(orderId);

//       try {
//         // Call backend endpoint to verify payment via Cashfree
//         const res = await axios.get(
//           `https://api.garudasena.org/api/payment/verify/${orderId}/${clientId}`
//         );

//         if (res.data.success) {
//           setIsSuccessful(true);
//           setStatusMessage("Payment completed successfully!");
//         } else {
//           setIsSuccessful(false);
//           setStatusMessage(
//             `Payment status: ${res.data.status || "FAILED"}`
//           );
//         }
//       } catch (error) {
//         console.error("Error verifying payment:", error);
//         setIsSuccessful(false);
//         setStatusMessage("Error verifying payment. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPaymentStatus();
//   }, []);

//   if (loading) {
//     return <div className="text-center mt-5">Loading payment status...</div>;
//   }

//   return (
//     <>
//       <Navbar />
//       <div className="container mt-5">
//         <div className="card-status">
//           <p className="text-center">
//             <strong>Transaction ID:</strong> {transactionId}
//           </p>

//           {isSuccessful === true && (
//             <div className="card-io card-success">
//               <div className="card-body text-center">
//                 <FaCheckCircle className="icon-success" />
//                 <h5 className="card-title">Payment Successful</h5>
//                 <p className="card-text">{statusMessage}</p>
//               </div>
//             </div>
//           )}

//           {isSuccessful === false && (
//             <div className="card-io card-failure">
//               <div className="card-body text-center">
//                 <FaTimesCircle className="icon-failure" />
//                 <h5 className="card-title">Payment Failed</h5>
//                 <p className="card-text">{statusMessage}</p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default PaymentStatus;


import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "./idex.css";
import axios from "axios";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const PaymentStatus = () => {
  const [loading, setLoading] = useState(true);
  const [isSuccessful, setIsSuccessful] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [transactionId, setTransactionId] = useState(null);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      const urlSegments = window.location.pathname.split("/");
      const orderId = urlSegments[urlSegments.length - 2];
      const clientId = urlSegments[urlSegments.length - 1];

      setTransactionId(orderId);

      try {
        const res = await axios.get(
          `https://api.garudasena.org/api/pay/verify/${orderId}/${clientId}`
        );

        if (res.data.success) {
          setIsSuccessful(true);
          setStatusMessage("Your payment was processed successfully!");
        } else {
          setIsSuccessful(false);
          setStatusMessage(`Payment status: ${res.data.status || "FAILED"}`);
        }
      } catch (error) {
        console.error("Error verifying payment:", error);
        setIsSuccessful(false);
        setStatusMessage("Error verifying payment. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentStatus();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loader"></div>
        <p>Checking your payment status...</p>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="payment-status-container">
        <div className={`status-card ${isSuccessful ? "success" : "failure"}`}>
          <div className="status-icon">
            {isSuccessful ? (
              <FaCheckCircle className="icon success-icon" />
            ) : (
              <FaTimesCircle className="icon failure-icon" />
            )}
          </div>

          <h2 className="status-title">
            {isSuccessful ? "Payment Successful" : "Payment Failed"}
          </h2>

          <p className="status-message">{statusMessage}</p>

          <div className="transaction-box">
            <strong>Transaction ID:</strong>
            <div className="transaction-id">{transactionId}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentStatus;
